import { render, staticRenderFns } from "./Vouchers.vue?vue&type=template&id=4ae25520"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"
import style0 from "./Vouchers.vue?vue&type=style&index=0&id=4ae25520&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports